import SpokenDialogueView from "@features/tools/view/spoken-dialogue-view/spoken-dialogue-view";

const SpokenDialogue = () => {
  return <SpokenDialogueView />;
};

export default SpokenDialogue;
